import { combineReducers } from '@reduxjs/toolkit';
import { getClientOrderSlice } from './clientOrderSlice';
import { getClientOrderDocumentsSlice } from './clientOrderDocumentsSlice';
import { postClientOrderCancellationSlice } from './clientOrderCancellation/clientPostOrderCancellationSlice';
import { getClientOrderCommentsSlice } from './clientOrderComments/clientOrderCommentsSlice';
import { postClientOrderCommentSlice } from './clientOrderComments/clientPostOrderCommentSlice';
import { getClientTitleSlice } from './clientTitleSlice';
import { updateClientLoanAmountSlice } from './clientOrderLoanAmountUpdateSlice';
import { updateClientSlice } from './clientOrderUpdateSlice';

export const clientReducer = combineReducers({
  clientOrder: getClientOrderSlice.reducer,
  clientOrderDocuments: getClientOrderDocumentsSlice.reducer,
  clientPostOrderCancellation: postClientOrderCancellationSlice.reducer,
  clientOrderComments: getClientOrderCommentsSlice.reducer,
  clientPostOrderComment: postClientOrderCommentSlice.reducer,
  clientTitle: getClientTitleSlice.reducer,
  clientLoanAmount: updateClientLoanAmountSlice.reducer,
  updateClientSlice: updateClientSlice.reducer,
});
